import { createContext, useContext } from 'react';

type ModalContainerContext = HTMLDivElement | null;

const context = createContext<ModalContainerContext>(null);

export function useModalContainerContext(): ModalContainerContext {
	return useContext(context);
}

export const ModalContainerContextConsumer = context.Consumer;
export const ModalContainerContextProvider = context.Provider;
